import React, { useEffect, useRef, useState } from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import "swiper/css/navigation";
import { Navigation } from "swiper/modules";
import bankimg from "../../../assets/bank.svg";
import {
  Button,
  Offcanvas,
  OverlayTrigger,
  Tooltip,
  Dropdown,
  Row,
  Col,
  Tabs,
  Tab,
  Card,
} from "react-bootstrap";
import Lottie from "lottie-react";
import notfoundData from "../../../assets/not_found.json";
import {
  IconPhone,
  IconShare,
  IconEdit,
  IconUser,
  IconCopy,
  IconMapPin,
  IconPaperclip,
  IconChevronLeft,
  IconFileTypeDoc,
  IconChevronRight,
  IconFileTypePdf,
  IconPhoto,
  IconUserCircle,
  IconClockHour3,
  IconArrowForwardUp,
  IconRefreshDot,
  IconLink,
  IconPackageExport,
  IconTruckDelivery,
  IconChecklist,
  IconContract,
  IconBox,
  IconRulerMeasure,
  IconFileDescription,
  IconMail,
  IconBuilding,
  IconBuildingSkyscraper,
  IconBuildingBank,
  IconPackage
} from "@tabler/icons-react";
import ComanConfirmationModal from "../../../components/ComanConfirmationModal";
import usePostRequest from "../../../hooks/usePostRequest";
import { API_ENDPOINTS } from "../../../constant/_constant";
import { toast } from "react-toastify";
import moment from "moment";
import { Navigate, useLocation, useNavigate } from "react-router-dom";
import SuccsessMsgModal from "../../../components/SuccessMsgModal";

const generateUniqueId = () => {
  const characters =
    "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
  let result = "";
  for (let i = 0; i < 8; i++) {
    const randomIndex = Math.floor(Math.random() * characters.length);
    result += characters.charAt(randomIndex);
  }
  const timestamp = Date.now().toString();
  const uniqueId = result + timestamp.slice(-4);
  return uniqueId;
};

function View_DetailsVendor({
  //  show,
  //  setShow,
  //  order,
  auto_id,
  isStatusUpdate,
  onStatusUpdate,
}) {
  const BASE_URL = process.env.REACT_APP_BASE_URL;
  const IMG = process.env.REACT_APP_BASE_URL_IMG;
  const [isOpen, setIsOpen] = useState(false);

  const [formId, setFormId] = useState(null);

  useEffect(() => {
    const newFormId = generateUniqueId();
    setFormId(newFormId);
    // reset();
  }, []);

  const { data: cardData, postData: fetchCard } = usePostRequest(
    API_ENDPOINTS.GET_CARD_INFO_VENDOR
  );

  useEffect(() => {
    if (auto_id) {
      // fetch details using the auto_id
      fetchCard({ auto_id: auto_id });
    }
  }, [auto_id]);

  const [isModalOpen, setIsModalOpen] = useState({
    show: false,
    action: null,
    message: "",
  });

  const [isEmaillOpen, setIsEmaillOpen] = useState({
    title: "",
    show: false,
    row: "",
    skuData: "",
    defaultSubject: "",
    Quote_No: "",
    ORDERID: "",
    toEmail: "",
    toName: "",
  });

  const [isCopyQuoteOpen, setIsCopyQuoteOpen] = useState({
    show: false,
    Feild: "",
    order_id: "",
    btnText: "",
    label: "",
  });

  const { isLoading: removeLoading, postData: statusChange } = usePostRequest(
    API_ENDPOINTS.ORDER_STATUS
  );

  const { isLoading: createLoading, postData: createORDER } = usePostRequest(
    API_ENDPOINTS.ORDER_CREATE
  );

  const onStatusSuccess = (response) => {
    toast.success(response.message);
    setShow({ isStatusUpdate: true });
    if (onStatusUpdate) {
      onStatusUpdate();
    }
    handleClose();
  };

  const onStatusError = (error) => {
    toast.error(error.message || "An error occurred during Status Change.");
  };

  const ChangeStatusHandler = (orderid, status) => {
    statusChange(
      { order_id: orderid, order_status: status },
      onStatusSuccess,
      onStatusError
    );
  };

  const openModal = (Orderid, status, Old_Status) => {
    // console.log("status");
    let modalMessage = `Are you sure you want to Change Status To "${Old_Status} To ${status}"`;
    let modalTitle = "Change Status";
    let type = "success";
    let modalIcon = <IconRefreshDot stroke={1} />;
    let actionHandler = () => {
      ChangeStatusHandler(Orderid, status);
    };
    let action = "Change";
    setIsModalOpen({
      show: true,
      action,
      message: modalMessage,
      onConfirm: actionHandler,
      title: modalTitle,
      icon: modalIcon,
      type: type,
    });
  };

  const [isSuccsessModalOpen, setIsSuccsessModalOpen] = useState({
    show: false,
    message: "",
    btntext: "Close",
    title: "Succsess",
  });

  const [order, setOrder] = useState(null);

  const [show, setShow] = useState(false);

  // console.log("order data", order);

  const location = useLocation();

  const searchParams = new URLSearchParams(location.search);
  const orderId = searchParams.get("order_id");

  // console.log("rfqId from query params:", orderId);

  // console.log("Full URL:", window.location.href);
  // console.log("location.search:", window.location.search);

  const { data: fetchedVendor, postData: fetchVendor } = usePostRequest(
    API_ENDPOINTS.GET_SINGLE_VENDOR
  );

  useEffect(() => {
    if (window.location.search) {
      const vendorId = window.location.search.slice(1);
      // console.log("rfqId to be used:", orderId);
      fetchVendor({ auto_id: vendorId });
    }
  }, [window.location.search]);

  useEffect(() => {
    if (fetchedVendor?.data) {
      setOrder(fetchedVendor.data); // Store fetched opportunity
      setShow(true);
    }
  }, [fetchedVendor]);

  const handleClose = () => {
    setShow(false);
    const newUrl = window.location.pathname;
    window.history.pushState(null, "", newUrl);
  };

  const ITEMS_PER_VIEW = 3.5;

  const navigate = useNavigate();

  const downloadImage = async (e, item) => {
    e.preventDefault();

    const imageUrl = `${BASE_URL}/common/download/${item?.file_name}`;
    const customFileName = item.original_name;

    try {
      const response = await fetch(imageUrl, {
        method: "GET",
      });

      const blob = await response.blob();
      const blobUrl = window.URL.createObjectURL(blob);

      const link = document.createElement("a");
      link.href = blobUrl;
      link.setAttribute("download", customFileName || "download.jpg");
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      window.URL.revokeObjectURL(blobUrl);
    } catch (error) {
      console.error("Download failed:", error);
    }
  };

  const handleShareClick = () => {
    const baseUrl = window.location.origin;
    const fullUrl = `${baseUrl}/list-rma?${order?.rma_id}`;

    // Check if the Clipboard API is available
    if (navigator.clipboard) {
      // Clipboard API is available, use it
      navigator.clipboard
        .writeText(fullUrl)
        .then(() => {
          console.log("Link copied to clipboard");
          toast.success("Link copied to clipboard");
        })
        .catch((error) => {
          console.error("Failed to copy: ", error);
        });
    } else {
      // Fallback: Use a temporary textarea to copy text for browsers that do not support Clipboard API
      const textarea = document.createElement("textarea");
      textarea.value = fullUrl;
      document.body.appendChild(textarea);
      textarea.select();
      document.execCommand("copy");
      document.body.removeChild(textarea);

      toast.success("Link copied to clipboard");
    }
  };

  const totalNotes = order?.section.reduce((acc, section) => {
    return acc + section.notes.length;
  }, 0);

  const handleModalClose = () => {
    setShow({ show: false });
    navigate("/list-order-lifecycle");
  };

  // const billingAdress = order?.billing_address || {};
  // let billingCity = "",
  //   billingState = "",
  //   billingCountry = "",
  //   billingStreet = "";
  // try {
  //   const billing = JSON.parse(billingAdress);
  //   billingCity = billing.City;
  //   billingState = billing.CountrySubDivisionCode;
  //   billingCountry = billing.Country;
  //   billingStreet = `${billing.Line1}${
  //     billing.Line2 ? `, ${billing.Line2}` : ""
  //   }`;
  // } catch (e) {
  //   console.error("Invalid billing address format", e);
  // }

  const parseIfString = (input) => {
    if (typeof input === "string") {
      try {
        return JSON.parse(input);
      } catch {
        return null;
      }
    }
    return input;
  };

  const safeString = (value) => (value == null ? "" : value);

  // Parse the billing address (can be string or object)
  const billingAddress =
    parseIfString(order?.VendorContact?.billing_address) || {};

  // Extract fields safely
  const billingCity = safeString(billingAddress.City);
  const billingState = safeString(billingAddress.CountrySubDivisionCode);
  const billingCountry = safeString(billingAddress.Country);
  const billingLine1 = safeString(billingAddress.Line1);
  const billingLine2 = safeString(billingAddress.Line2);
  const billingPostalCode = safeString(billingAddress.PostalCode);

  return (
    <>
      <Offcanvas
        name="Detail"
        show={show}
        // onHide={handleClose}
        // onHide={() => setShow({ show: false })}
        onHide={handleClose}
        placement="end"
      >
        <Offcanvas.Header closeButton>
          <Offcanvas.Title>
            <div className="head_title">
              <h2>Company Name: {order?.display_name}</h2>
            </div>
          </Offcanvas.Title>
        </Offcanvas.Header>

        <Offcanvas.Body>
          {/* <div className="head_title">
            <h2>Customer ID: {order?.auto_id}</h2>
          </div> */}
          <div className="full_details border-0 pt-0">
            <h5 className="mb-3 fw-bold">Billing Details</h5>

            <Row className="flex_rows">
              <Col lg={4} md={5}>
                <p className="d-flex align-items-center gap-1">
                  <IconPackage stroke={1} width={20} /> 
                  Vendor Type:
                </p>
              </Col>
              <Col lg={8} md={7}>
                <b>
                  {order?.vendor_type}
                </b>
              </Col>
            </Row>

            
            <Row className="flex_rows">
              <Col lg={4} md={5}>
                <p className="d-flex align-items-center gap-1">
                  <IconUser stroke={1} width={20} /> Full Name:
                </p>
              </Col>
              <Col lg={8} md={7}>
                <b>
                  {order?.first_name || order?.last_name
                    ? `${order?.first_name || ""} ${
                        order?.last_name || ""
                      }`.trim()
                    : "N/A"}
                </b>
              </Col>
            </Row>
            <Row className="flex_rows">
              <Col lg={4} md={5}>
                <p className="d-flex align-items-center gap-1">
                  <IconPhone stroke={1} width={20} />
                  Phone Number:
                </p>
              </Col>
              <Col lg={8} md={7}>
                <b>
                  {parseIfString(order?.VendorContact?.primary_phone)
                    ?.FreeFormNumber || "N/A"}
                </b>
              </Col>
            </Row>
            <Row className="flex_rows">
              <Col lg={4} md={5}>
                <p className="d-flex align-items-center gap-1">
                  <IconMail stroke={1} width={20} /> Email ID:
                </p>
              </Col>
              <Col lg={8} md={7}>
                <b>
                  {parseIfString(order?.VendorContact?.primary_email)
                    ?.Address || "N/A"}
                </b>
              </Col>
            </Row>
            <Row className="flex_rows">
              <Col lg={4} md={5}>
                <p className="d-flex align-items-center gap-1">
                  <IconMapPin stroke={1} width={20} /> Address:
                </p>
              </Col>
              <Col lg={8} md={7}>
                <b>
                  {billingAddress &&
                  (billingLine1 ||
                    billingLine2 ||
                    billingCity ||
                    billingState ||
                    billingPostalCode ||
                    billingCountry) ? (
                    <>
                      {[
                        billingLine1,
                        billingLine2,
                        billingCity,
                        billingState,
                        billingPostalCode,
                        billingCountry,
                      ]
                        .filter(Boolean)
                        .join(", ")}
                    </>
                  ) : (
                    "N/A"
                  )}
                </b>
              </Col>
            </Row>

            <Row className="flex_rows">
              <Col lg={4} md={5}>
                <p className="d-flex align-items-center gap-1">
                  <IconBuilding stroke={1} width={20} /> City:
                </p>
              </Col>
              <Col lg={8} md={7}>
                <b>{billingCity || "N/A"}</b>
              </Col>
            </Row>

            <Row className="flex_rows">
              <Col lg={4} md={5}>
                <p className="d-flex align-items-center gap-1">
                  <IconBuildingSkyscraper stroke={1} width={20} /> State:
                </p>
              </Col>
              <Col lg={8} md={7}>
                <b>{billingState || "N/A"}</b>
              </Col>
            </Row>

            <Row className="flex_rows">
              <Col lg={4} md={5}>
                <p className="d-flex align-items-center gap-1">
                  <IconMapPin stroke={1} width={20} /> Country:
                </p>
              </Col>
              <Col lg={8} md={7}>
                <b>{billingCountry || "N/A"}</b>
              </Col>
            </Row>
          </div>

          <div className="attetchment_row">
            <p>
              <IconPaperclip stroke={1} width={20} /> Attachments{" "}
              <span>({order?.Attachments?.length || 0})</span>
            </p>
            <div className="carousel-container">
              {order?.Attachments && order?.Attachments?.length > 0 ? (
                <>
                  <Swiper
                    slidesPerView={3}
                    spaceBetween={15}
                    loop={true}
                    navigation={true}
                    modules={[Navigation]}
                    className="mySwiper"
                  >
                    {order.Attachments?.map((item, index) => {
                      const fileExtension = item.original_name
                        .split(".")
                        .pop()
                        .toLowerCase();

                      let fileIcon;
                      if (fileExtension === "pdf") {
                        fileIcon = (
                          <IconFileTypePdf
                            stroke={1}
                            width={45}
                            height={45}
                            style={{ color: "#D63939" }}
                          />
                        );
                      } else if (
                        [
                          "jpg",
                          "jpeg",
                          "png",
                          "gif",
                          "bmp",
                          "svg",
                          "webp",
                        ].includes(fileExtension)
                      ) {
                        fileIcon = (
                          <IconPhoto
                            stroke={1}
                            width={45}
                            height={45}
                            style={{ color: "#AE3EC9" }}
                          />
                        );
                      } else {
                        fileIcon = (
                          <IconFileTypeDoc
                            stroke={1}
                            width={45}
                            height={45}
                            style={{ color: "#4299E1" }}
                          />
                        );
                      }
                      return (
                        <SwiperSlide key={index} className="mySwiper">
                          <div className="card">
                            {item.type === "LINK" ? (
                              <a
                                href={item?.file_name}
                                target="_blank"
                                className="attetch_flex"
                              >
                                <IconLink
                                  stroke={1}
                                  width={45}
                                  height={45}
                                  style={{ color: "#4299E1" }}
                                />
                                <div className="attetch_info">
                                  <b>{item.original_name}</b>
                                  <p className="d-flex gap-3 mb-0">
                                    <span>LINK</span>
                                  </p>
                                </div>
                              </a>
                            ) : (
                              <div className="attetch_flex">
                                <div>{fileIcon}</div>
                                <div
                                  className="attetch_info"
                                  // onClick={(e) => {
                                  //   downloadImage(e, item.file_name);
                                  // }}
                                >
                                  <b>{item.original_name}</b>
                                  <p className="d-flex gap-3 mb-0">
                                    <span
                                      onClick={(e) => {
                                        downloadImage(e, item);
                                      }}
                                    >
                                      Download
                                    </span>
                                    <a
                                      className="text-blue"
                                      href={`${IMG}uploads/attachments/${item.file_name}`}
                                      target="_blank"
                                      rel="noopener noreferrer"
                                    >
                                      Preview
                                    </a>
                                  </p>
                                </div>
                              </div>
                            )}
                          </div>
                        </SwiperSlide>
                      );
                    })}
                  </Swiper>
                </>
              ) : (
                <p>No Attachments available</p>
              )}
            </div>
          </div>

          <div className="tabs_details">
            <Tabs
              defaultActiveKey="Payment"
              id="uncontrolled-tab-example"
              className="mb-3"
            >
              <Tab
                eventKey="Payment"
                title={
                  <>
                    Payment Details{" "}
                    <span className="badge bg-indigo-lt">
                      {cardData?.data?.length || 0}
                    </span>
                  </>
                }
              >
                {cardData?.data?.length === 0 ? (
                  <div className="data_not_available text-center pb-4">
                    <Lottie animationData={notfoundData} />
                    <p>No payment details available</p>
                  </div>
                ) : (
                  <Row className="g-3">
                    {cardData?.data?.map((item) => (
                      <Col md={12} key={item.id}>
                        <Card className="status_item_card w-100">
                          <Card.Body>
                            <div className="d-flex gap-2 align-items-center">
                              <img src={bankimg}></img>
                              <div className="w-100">
                                <b>{item.info_bank || "Bank Not Provided"}</b>
                                <div className="d-flex gap-1 align-items-center">
                                  Card No:
                                  <p className="mb-0">
                                    {item.info_number || "N/A"} (Last 4 digits)
                                  </p>
                                </div>
                                <div className="d-flex  gap-1 align-items-center">
                                  Cardholder Name:
                                  <p className="mb-0">
                                    {item.info_name || "N/A"}
                                  </p>
                                </div>
                              </div>
                            </div>
                          </Card.Body>
                        </Card>
                      </Col>
                    ))}
                  </Row>
                )}
              </Tab>
              <Tab
                eventKey="Notes"
                title={
                  <>
                    Notes{" "}
                    <span className="badge bg-indigo-lt">{totalNotes}</span>
                  </>
                }
              >
                {order?.section.length === 0 ? (
                  <div className="data_not_available text-center pb-4">
                    <Lottie animationData={notfoundData} />{" "}
                    <p>No notes available</p>
                  </div>
                ) : (
                  order?.section.map((section) => (
                    <div key={section.id}>
                      {section.notes.length > 0 ? (
                        section.notes.map((note) => (
                          <Card
                            className="status_item_card w-100"
                            key={note.id}
                          >
                            <Card.Body>
                              <div className="flex_note_head mb-1">
                                <span className="badge bg-indigo-lt">
                                  {section.name.charAt(0).toUpperCase() +
                                    section.name.slice(1)}
                                  .
                                </span>
                                <div className="note_info_time">
                                  <span className="note_user">
                                    <IconUserCircle /> {note.User.first_name}{" "}
                                    {note.User.last_name}
                                  </span>
                                  <p className="note_user mb-0">
                                    <IconClockHour3 />{" "}
                                    {moment(note.createdAt).format(
                                      "MM/DD/YYYY hh:mm A"
                                    )}
                                  </p>
                                </div>
                              </div>
                              <p className="mb-0">{note.note}</p>
                            </Card.Body>
                          </Card>
                        ))
                      ) : (
                        <div className="data_not_available text-center pb-4">
                          <Lottie animationData={notfoundData} />
                          <p>No notes available</p>
                        </div>
                      )}
                    </div>
                  ))
                )}
              </Tab>
            </Tabs>
          </div>
        </Offcanvas.Body>
      </Offcanvas>
      <ComanConfirmationModal
        show={isModalOpen.show}
        onHide={() => {
          setIsModalOpen({ ...isModalOpen, show: false });
          setIsOpen(false);
        }}
        title={isModalOpen.title}
        message={isModalOpen.message}
        onConfirm={isModalOpen.onConfirm}
        icon={isModalOpen.icon}
        type={isModalOpen.type}
      />
      <SuccsessMsgModal
        show={isSuccsessModalOpen.show}
        onHide={() =>
          setIsSuccsessModalOpen(
            { ...isSuccsessModalOpen, show: false }
            // navigate("/dashboard")
          )
        }
        title={isSuccsessModalOpen?.title}
        btntext={isSuccsessModalOpen?.btntext}
        message={isSuccsessModalOpen?.message}
      />
    </>
  );
}

export default View_DetailsVendor;
